import React, { useState }  from 'react';
import { PageContext } from './providers/page-provider';
import { HealthAssesment } from './providers/health-assesment-provider';
import { clone } from 'lodash';
import axios from 'axios';

import {
  StepOne,
  StepTwo,
  StepThree,
  StepFour,
  StepFiveWithFormulas
} from './pages';

import {
  HealthAssesmentScoreWithFormulas
} from './layouts/health-assesment-score/health-assesment-score';

const PAGES = { 
  "STEP_ONE": StepOne,
  "STEP_TWO": StepTwo,
  "STEP_THREE": StepThree,
  "STEP_FOUR": StepFour,
  "STEP_FIVE": StepFiveWithFormulas,
  "SCORE_PAGE": HealthAssesmentScoreWithFormulas
}

export const HealthAssesmentContainer = () => {
  const [currentStep, setCurrentStep] = useState("STEP_ONE");
  const [stepsSubmitted, setStepsSubmitted] = useState([]);
  const [healthAssesmentData, setHealthAssesmentData] = useState({
    arCosts: {
      ach: "25",
      pc: "25",
      cc: "25",
      other: "25",
      b: "2",
      c: "250"
    },
    cashFlow: {
      a: "30",
      b: "240",
      c: "50",
      d: "50",
      e: "50"
    },
    scalability: {
      a: "15",
      b: "60",
      c: "manual",
      d: "no"
    },
    resilience: {
      a: "no",
      b: "no",
      c: "no",
      d: "6",
      e: "50"
    },
    general: {
      a: "10",
      b: "",
      c: "",
      d: "",
      e: "",
      f: "",
      g: ""
    },
    score: {
      overallScore: "",
      arCostsScore: "",
      cashFlowScore: "",
      scalabilityScore: "",
      resiliencyScore: ""
    }
  });

  const handleNextPage = ({from, to}) => {
    setStepsSubmitted([...stepsSubmitted, from]);
    setCurrentStep(to);
    if (from === "STEP_FIVE") {
      sendForm();
    }
  };

  const handlePreviousPage = ({to}) => {
    const currentSteps = clone(stepsSubmitted);
    currentSteps.pop()
    setStepsSubmitted(currentSteps);
    setCurrentStep(to);
  };

  const addHealthAssesmentData = ({question, name, value}) => {
    const newState = clone(healthAssesmentData);
    newState[question][name] = value;
    setHealthAssesmentData(newState);
  };

  const prepareValuesForm = () => {
    const data = clone(healthAssesmentData);
    const form = [
      {
        "name": "payment_mix_ach",
        "value": parseInt(data.arCosts.ach)
      },
      {
        "name": "payment_mix_paper_check",
        "value": parseInt(data.arCosts.pc)
      },
      {
        "name": "payment_mix_credit_card",
        "value": parseInt(data.arCosts.cc)
      },
      {
        "name": "payment_mix_other",
        "value": parseInt(data.arCosts.other)
      },
      {
        "name": "credit_card_rate",
        "value": parseFloat(data.arCosts.b)
      },
      {
        "name": "recurring_monthly_costs",
        "value": parseInt(data.arCosts.c) * 1000
      },
      {
        "name": "dso",
        "value": parseInt(data.cashFlow.a)
      },
      {
        "name": "invoices_created_monthly",
        "value": parseInt(data.cashFlow.b)
      },
      {
        "name": "invoices_outstanding_monthly",
        "value": parseInt(data.cashFlow.c)
      },
      {
        "name": "first_time_customers",
        "value": parseInt(data.cashFlow.d)
      },
      {
        "name": "returning_customers",
        "value": parseInt(data.cashFlow.e)
      },
      {
        "name": "yoy_revenue_growth_rate",
        "value": parseInt(data.scalability.a)
      },
      {
        "name": "manual_hours_per_month",
        "value": parseInt(data.scalability.b)
      },
      {
        "name": "reconciliation_method",
        "value": data.scalability.c
      },
      {
        "name": "pay_now_button",
        "value": data.scalability.d
      },
      {
        "name": "payer_pays_fees",
        "value": data.resilience.a
      },
      {
        "name": "remote_operations",
        "value": data.resilience.b
      },
      {
        "name": "financing_receivables",
        "value": data.resilience.c
      },
      {
        "name": "team_size",
        "value": parseInt(data.resilience.d)
      },
      {
        "name": "retention_rate",
        "value": parseInt(data.resilience.e)
      },
      {
        "name": "annualrevenue",
        "value": parseInt(data.general.a) * 1000000
      },
      {
        "name": "accounting_erp_software",
        "value": data.general.b
      },
      {
        "name": "numemployees",
        "value": data.general.c
      },
      {
        "name": "firstname",
        "value": data.general.d
      },
      {
        "name": "lastname",
        "value": data.general.e
      },
      {
        "name": "jobtitle",
        "value": data.general.f
      },
      {
        "name": "email",
        "value": data.general.g
      },
      {
        "name": "ar_health_results_overall_score",
        "value": parseInt(data.score.overallScore)
      },
      {
        "name": "ar_health_results_ar_costs",
        "value": parseInt(data.score.arCostsScore)
      },
      {
        "name": "ar_health_score_cash_flow",
        "value": parseInt(data.score.cashFlowScore)
      },
      {
        "name": "ar_health_results_scalability",
        "value": parseInt(data.score.scalabilityScore)
      },
      {
        "name": "ar_health_results_resiliency_score",
        "value": parseInt(data.score.resiliencyScore)
      }
    ];

    return form;
  }

  const sendForm = async () => {
    const fields = prepareValuesForm();
    const portalId = "493201";
    const formGuid = "e47e6027-63a6-44d1-b138-ac4f72636ec2"
    const data = {
      "submittedAt": Date.now(),
      "fields": fields,
      "context": {
        "pageUri": "www.arhealth.paystand.com",
        "pageName": "AR Health Assesment"
      }
    }

    const dataJson = JSON.stringify(data)

    try {
      const response = await axios({
        method: 'post',
        headers: {'Content-Type': 'application/json'},
        url: `https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formGuid}`,
        data: dataJson
      });
      console.log("response: ", response);
    } catch (error) {
      console.log("error: ", error);
    }
  }

  const CurrentPage = PAGES[currentStep];
  return (
    <HealthAssesment.Provider value={{ healthAssesmentData, addHealthAssesmentData }}>
      <PageContext.Provider value={{ currentStep, handleNextPage, handlePreviousPage, stepsSubmitted }}>
        <CurrentPage />
      </PageContext.Provider>
    </HealthAssesment.Provider>
  )
};